import React, { Component } from "react";
import AdminHeader from "../../components/dashboardheader/adminheader";
import Finxfooter from "../finxfooter/finxfooter";
import VideoListLandingPage from "../../components/video/videoList";
import { VideoService } from "../../services/video.service";

class videoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getVideoList: [],
      fromDate:"",
      toDate:"",
    };
  }
  componentDidMount() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setDate(endDate.getDate() - 31);
    // let params = "fromDate=" + startDate.toLocaleDateString() + "&toDate=" + endDate.toLocaleDateString();
    // console.log('params',params);
    // this.setState({
    //     fromDate:startDate.toLocaleDateString(),
    //     toDate:endDate.toLocaleDateString(),
    //   });
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    let dateFormatter = new Intl.DateTimeFormat('en-IN', options);
    let fromDate = dateFormatter.format(startDate);
    let toDate = dateFormatter.format(endDate);
    let params = `fromDate=${fromDate}&toDate=${toDate}`;
    this.setState({
      fromDate: fromDate,
      toDate: toDate,
    });
    VideoService.videoReportList(params, (res) => {
      if (res.status === "success") {
        this.setState({
          loading: false,
          getVideoList: res.responseListObject,
        });
      } else {
        this.setState({
          loading: false,
          getVideoList: [],
          fromDate: "",
          toDate: "",
        });
      }
    });
  }
  render() {
    // console.log("videolist", this.state);

    const { getVideoList,fromDate,toDate } = this.state;
    return (
      <>
        <AdminHeader {...this.props} />
        <VideoListLandingPage 
        getVideoList={getVideoList}
        fromDate={fromDate}
        toDate={toDate}
        {...this.props} />
        <Finxfooter />
      </>
    );
  }
}

export default videoList;
